import React from 'react'
import NavCardList from '../../../Partials/Layouts/NavCardList/NavCardList'
import NavCard from '../../../Partials/Layouts/NavCardList/NavCard/NavCard'
import { RiGroupLine, RiUserShared2Line } from 'react-icons/ri'

function EmployeeScreen() {
    return (
        <NavCardList numOfCards={'four'}>
            <NavCard cardName={'Employees'} navCardLink='/employees' ><RiGroupLine /></NavCard>
            <NavCard cardName={'Employee Invites'} navCardLink='/employeeInvites' ><RiUserShared2Line /></NavCard>
        </NavCardList>
    )
}

export default EmployeeScreen